<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="PagamentoIndicacaoGuias"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <BuscarSelecionarProfissional
              :minimo="1"
              label="Profissional"
              @selecionadoProfissional="profissionalId = $event._id"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <SelecionarUnidade
              mostrar-todos
              chave="_id"
              @atualizar="unidade = $event"
            />
          </div>
        </div>
        <br />
      </template>
    </BlocoFiltroPesquisa>
    <div class="relatorio-main">
      <div v-if="!carregando && !comFaturamento && !semFaturamento" class="row">
        <div class="well">
          <h3>Nenhum dado encontrado</h3>
        </div>
      </div>

      <div>
        <div v-if="resultado.guias" class="row">
          <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div
              v-for="(item, index) in resultado.guias"
              id="panels"
              :key="item.numero_guia"
              class="panel-group"
              role="tablist"
              aria-multiselectable="true"
            >
              <div
                class="panel panel-primary"
                :class="{ 'guia-completa': isGuiaCompleta(item) }"
              >
                <div :id="'item' + index" class="panel-heading" role="tab">
                  <span class="cabecalho-guia">
                    <span>{{ item.numero_guia }}</span>
                    <span class="pull-right cabecalho-guia">
                      <strong> | Total de sessões indicadas:</strong>
                      {{ item.numero_sessoes_indicacadas }}
                    </span>
                    <span class="pull-right cabecalho-guia">
                      <strong>Total de sessões faturadas:</strong>
                      {{ item.numero_sessoes_faturadas }}
                    </span>
                  </span>
                </div>
                <div class="panel-collapse">
                  <table class="table table-striped table-hover table-bordered">
                    <thead>
                      <tr style="background-color: #008080; color: white">
                        <td class="text-center tabela-head"
                          >Nome do paciente</td
                        >
                        <td class="text-center tabela-head">Especialidade</td>
                        <td class="text-center tabela-head">Unidade</td>
                        <td class="text-center tabela-head">Convênio</td>
                        <td class="text-center tabela-head">Procedimentos</td>
                        <td class="text-right tabela-head"
                          >Total enviado (R$)</td
                        >
                        <td class="text-right tabela-head">Total glosa (R$)</td>
                        <td class="text-right tabela-head">Total pago (R$)</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center cell">{{ item.paciente }}</td>
                        <td class="text-center cell">{{
                          item.especialidade
                        }}</td>
                        <td class="text-center cell">{{ item.unidade }}</td>
                        <td class="text-center cell">{{ item.convenio }}</td>
                        <td class="cell">
                          {{ item.procedimento }}
                        </td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_enviado)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_glosa)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_pago)
                        }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'
import * as formatadores from '@/utils/formatadores'

const mensagemServico = new MensagemServico()
const relatorioServico = new RelatorioServico()

export default {
  components: {
    BlocoFiltroPesquisa,
    BuscarSelecionarProfissional,
    SelecionarUnidade,
  },
  setup() {
    useMenu(74)
  },
  data() {
    return {
      carregando: false,
      unidade: null,
      profissionalId: '',
      resultado: {
        guias: [],
      },
    }
  },
  computed: {
    comFaturamento() {
      return this.resultado.guias?.length
    },
  },
  methods: {
    ...formatadores,
    isGuiaCompleta(item) {
      return item.total_sessoes >= item.total_sessoes_guia
    },
    pesquisar() {
      this.resultado.guias = []
      this.carregando = true

      relatorioServico
        .relatorioPagamentoIndicacaoGuia({
          id_profissional: this.profissionalId,
          unidade: this.unidade,
        })
        .then((result) => {
          this.carregando = false

          this.resultado.guias = result.relatorio
        })
        .catch((error) => {
          this.carregando = false
          console.error('Erro ao buscar relatório:', error)
          mensagemServico.erro('Erro ao buscar relatório. Tente novamente.')
        })
    },
  },
}
</script>

<style scoped>
.cabecalho-guia {
  color: white;
}

.relatorio-main {
  padding: 20px;
}

.guia-completa .panel-heading {
  background-color: #008080 !important;
  border-color: #008080 !important;
}

.guia-completa-icon {
  margin-left: 6px;
  color: #fff;
  font-size: 14px;
}

.guia-completa .panel-body,
.guia-completa .panel-collapse {
  background-color: #f8fdfd;
}
</style>
